export type KeyboardFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type KeyboardFilterGroup = {
  id: string;
  label: string;
  options: KeyboardFilterOption[];
};

export const keyboardFilterGroups: KeyboardFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'akko', label: 'AKKO', keywords: ['akko'] },
      { value: 'angry-miao', label: 'ANGRY MIAO', keywords: ['angry miao'] },
      { value: 'apple', label: 'APPLE', keywords: ['apple'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus'] },
      { value: 'aula', label: 'AULA', keywords: ['aula'] },
      { value: 'bjx', label: 'BJX', keywords: ['bjx'] },
      { value: 'cooler-master', label: 'COOLER MASTER', keywords: ['cooler master'] },
      { value: 'corsair', label: 'CORSAIR', keywords: ['corsair'] },
      { value: 'dareu', label: 'DAREU', keywords: ['dareu'] },
      { value: 'dell', label: 'DELL', keywords: ['dell'] },
      { value: 'e-dra', label: 'E-DRA', keywords: ['e-dra', 'edra'] },
      { value: 'fd', label: 'FD', keywords: ['fd'] },
      { value: 'fuhlen', label: 'FUHLEN', keywords: ['fuhlen'] },
      { value: 'g21', label: 'G21', keywords: ['g21'] },
      { value: 'g-net', label: 'G-NET', keywords: ['g-net', 'gnet'] },
      { value: 'golden-field', label: 'GOLDEN FIELD', keywords: ['golden field'] },
      { value: 'gtx350', label: 'GTX350', keywords: ['gtx350'] },
      { value: 'hp', label: 'HP', keywords: ['hp'] },
      { value: 'iqunix', label: 'IQUNIX', keywords: ['iqunix'] },
      { value: 'lc-power', label: 'LC-POWER', keywords: ['lc-power', 'lc power'] },
      { value: 'lenovo', label: 'LENOVO', keywords: ['lenovo'] },
      { value: 'logitech', label: 'LOGITECH', keywords: ['logitech'] },
      { value: 'machenike', label: 'MACHENIKE', keywords: ['machenike'] },
      { value: 'mikit', label: 'MIKIT', keywords: ['mikit'] },
      { value: 'motospeed', label: 'MOTOSPEED', keywords: ['motospeed'] },
      { value: 'newmen', label: 'NEWMEN', keywords: ['newmen'] },
      { value: 'nzxt', label: 'NZXT', keywords: ['nzxt'] },
      { value: 'ocpc', label: 'OCPC', keywords: ['ocpc'] },
      { value: 'rapoo', label: 'RAPOO', keywords: ['rapoo'] },
      { value: 'razer', label: 'RAZER', keywords: ['razer'] },
      { value: 'redragon', label: 'REDRAGON', keywords: ['redragon'] },
      { value: 'royal-kludge', label: 'ROYAL KLUDGE', keywords: ['royal kludge', 'rk'] },
      { value: 'samsung', label: 'SAMSUNG', keywords: ['samsung'] },
      { value: 'vitra', label: 'VITRA', keywords: ['vitra'] },
      { value: 'xiberia', label: 'XIBERIA', keywords: ['xiberia'] },
      { value: 'xinmeng', label: 'XINMENG', keywords: ['xinmeng'] },
    ],
  },
  {
    id: 'need',
    label: 'Nhu cầu',
    options: [
      { value: 'gaming', label: 'Gaming', keywords: ['gaming'] },
      { value: 'office', label: 'Văn phòng', keywords: ['van phong', 'office'] },
    ],
  },
  {
    id: 'type',
    label: 'Loại bàn phím',
    options: [
      {
        value: 'mechanical',
        label: 'Bàn phím cơ (Mechanical)',
        keywords: ['mechanical', 'phim co'],
      },
      { value: 'hybrid', label: 'Bàn phím giả cơ', keywords: ['gia co', 'hybrid'] },
      { value: 'combo', label: 'Combo phím chuột', keywords: ['combo'] },
    ],
  },
  {
    id: 'connectivity',
    label: 'Kết nối',
    options: [
      { value: '3mode', label: '3 Mode', keywords: ['3 mode', '3-mode', 'tri-mode'] },
      { value: 'wired', label: 'Có dây', keywords: ['co day', 'wired', 'usb'] },
      {
        value: 'wireless',
        label: 'Wireless',
        keywords: ['wireless', 'khong day', 'bluetooth', '2.4ghz'],
      },
    ],
  },
  {
    id: 'size',
    label: 'Kích cỡ',
    options: [
      {
        value: 'fullsize',
        label: 'Fullsize',
        keywords: ['fullsize', '100%', '104 key', '108 key'],
      },
      { value: 'tkl', label: 'Tenkeyless', keywords: ['tenkeyless', 'tkl', '80%', '87 key'] },
      { value: 'mini', label: 'Mini', keywords: ['mini', '60%', '65%', '75%', 'compact'] },
    ],
  },
  {
    id: 'switch',
    label: 'Switch',
    options: [
      { value: 'clicky', label: 'Clicky', keywords: ['clicky', 'blue switch'] },
      {
        value: 'linear',
        label: 'Linear',
        keywords: ['linear', 'red switch', 'black switch', 'yellow switch'],
      },
      { value: 'magnetic', label: 'Magnetic', keywords: ['magnetic', 'tu tinh'] },
      { value: 'membrane', label: 'Membrane', keywords: ['membrane', 'phim cao su'] },
      { value: 'optical', label: 'Optical', keywords: ['optical', 'quang hoc'] },
      { value: 'silent', label: 'Silent', keywords: ['silent'] },
      { value: 'tactile', label: 'Tactile', keywords: ['tactile', 'brown switch'] },
    ],
  },
  {
    id: 'other',
    label: 'Thông tin khác',
    options: [
      { value: 'hotswap', label: 'Hot Swap', keywords: ['hot swap', 'hotswap'] },
      { value: 'rapid-trigger', label: 'Rapid Trigger', keywords: ['rapid trigger'] },
      {
        value: 'aluminum',
        label: 'Vỏ nhôm',
        keywords: ['vo nhom', 'aluminum', 'nhom nguyen khoi'],
      },
    ],
  },
];
